import { useEffect, useState } from "react";
import { motion, useMotionValue, useSpring } from "framer-motion";

export default function Cursor() {
  const x = useMotionValue(-100);
  const y = useMotionValue(-100);
  const sx = useSpring(x, { stiffness: 500, damping: 40, mass: 0.4 });
  const sy = useSpring(y, { stiffness: 500, damping: 40, mass: 0.4 });
  const [hover, setHover] = useState(false);
  const [enabled, setEnabled] = useState(false);

  useEffect(() => {
    if (!window.matchMedia("(pointer: fine)").matches) return;
    setEnabled(true);
    document.documentElement.classList.add("custom-cursor");
    const move = (e) => {
      x.set(e.clientX);
      y.set(e.clientY);
      setHover(!!e.target.closest("a, button, input, select, textarea, label, [role=button]"));
    };
    window.addEventListener("mousemove", move, { passive: true });
    return () => {
      window.removeEventListener("mousemove", move);
      document.documentElement.classList.remove("custom-cursor");
    };
  }, [x, y]);

  if (!enabled) return null;
  return (
    <motion.div
      aria-hidden
      style={{ x: sx, y: sy }}
      className="fixed top-0 left-0 z-[300] pointer-events-none -translate-x-1/2 -translate-y-1/2 mix-blend-difference"
      data-testid="custom-cursor"
    >
      <motion.div
        animate={{ width: hover ? 44 : 10, height: hover ? 44 : 10, opacity: hover ? 0.9 : 1 }}
        transition={{ type: "spring", stiffness: 300, damping: 25 }}
        className="rounded-full bg-gold -translate-x-1/2 -translate-y-1/2"
      />
    </motion.div>
  );
}
